/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_DeniedInputs */

const cs_settings_calendar_denied = /** @type {(inputs: Settings_Calendar_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlášení ke kalendáři bylo zrušeno.`)
};

const en_settings_calendar_denied = /** @type {(inputs: Settings_Calendar_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendar sign-in was cancelled.`)
};

/**
* | output |
* | --- |
* | "Calendar sign-in was cancelled." |
*
* @param {Settings_Calendar_DeniedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_denied = /** @type {((inputs?: Settings_Calendar_DeniedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_DeniedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_denied(inputs)
	return cs_settings_calendar_denied(inputs)
});